// An older response, error or finally must never replace a newer result.
export const createLatestRequestGate = () => {
  let version = 0;
  return {
    begin() {
      const request = ++version;
      return { isCurrent: () => request === version };
    },
    invalidate() { version += 1; },
  };
};

// Keep post-mutation refreshes attached to the last committed filter/page view.
export const createCurrentRefresh = () => {
  let callback = null;
  return {
    setCallback(next) { callback = next; },
    refresh() { return callback?.(); },
    clear() { callback = null; },
  };
};
